import React, { Suspense, useState } from "react";
import { Await, Navigate } from "react-router";
import { showError } from "../ToastedMessage/ToastedMessage";
import CustomLoader from "../controls/CustomLoader";
import useBookingApp from "../../hooks/useBookingApp";
const AsyncRendererRouter = ({
  loadingElement,
  isLoading,
  resolve,
  errorElement,
  children,
}) => {
  const [redirectUrl, setRedirectUrl] = useState(null);
  const { appState } = useBookingApp();
  try {
    if (typeof resolve?.then === "function") {
      resolve?.then((data) => {
        if (data instanceof Response) {
          const toUrl = data?.headers?.get("location") || "/NotFound";
          setRedirectUrl(toUrl);
        }
      });
    }
  } catch (error) {}
  return (
    <Suspense fallback={loadingElement || <CustomLoader />}>
      <Await
        resolve={resolve}
        errorElement={() => {
          if (errorElement) {
            return errorElement;
          }
          showError("Something went wrong.");
          return <></>;
        }}
      >
        {redirectUrl !== null ? (
          <Navigate replace={true} to={redirectUrl} />
        ) : isLoading ? (
          loadingElement || <CustomLoader />
        ) : appState?.isAppLoading === true ? (
          <CustomLoader />
        ) : (
          children
        )}
      </Await>
    </Suspense>
  );
};
export default AsyncRendererRouter;
